import { DetailedTicketSource } from '@sb-tools/typescript/enums/detailed-ticket-source.enum';
import { TicketStatus } from '../enums/ticket-status.enum';
import { Sentiments } from 'src/sb-modules/Frontend-form-field-module/common/enums/sentiments.enum';
import { FileModelExtended } from '@sb-tools/typescript/models/FileModelExtended.model';
import { Field } from '@sb-tools/typescript/models/field.model';
import { FieldType } from '@sb-tools/typescript/enums/field-type.enum';
import { FieldValue } from '@form-field-module/common/models/field-value.model';
import { AddTicketModel } from '@form-field-module/common/models/add-ticket-model.model';

export class OutlookTicketModel {
    assigneeId: string;
    attachments: FileModelExtended[];
    category: Field;
    categoryId?: number;
    cc: string[];
    community: string;
    content: string;
    fields?: FieldValue[];
    email: string;
    formId?: number;
    isSendToClient?: boolean;
    isTextContent?: boolean;
    itemId: string;
    message: string;
    name: string;
    sentiment: Sentiments;
    sourceEmail: string;
    status: TicketStatus;
    subject: string;
    tags: string[];
    ticketSource: DetailedTicketSource;
    title: string;

    constructor(formModel, fieldsValidator?) {
        formModel.fields = AddTicketModel.setMapToTickedForDependedFields(formModel.fields);
        this.attachments = formModel.attachments;
        this.assigneeId = AddTicketModel.getFormElementValue(formModel.fields, FieldType.assignee);
        this.categoryId = AddTicketModel.getFormElementValue(formModel.fields, FieldType.categories);
        this.cc = formModel.cc;
        this.fields = AddTicketModel.getFields(formModel.fields, fieldsValidator);
        this.email = formModel.email;
        this.formId = null;
        this.isSendToClient = false;
        this.isTextContent = false;
        this.itemId = formModel.itemId;
        this.message = AddTicketModel.getFormElementValue(formModel.fields, FieldType.message);
        this.name = formModel.name;
        this.sentiment = Sentiments.question;
        this.sourceEmail = formModel.sourceEmail;
        this.status = AddTicketModel.getFormElementValue(formModel.fields, FieldType.status);
        this.tags = [];
        this.ticketSource = DetailedTicketSource.emailOutlookPlugin;
        this.title = AddTicketModel.getFormElementValue(formModel.fields, FieldType.title);
    }
}
